import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFormattedDateTime } from '../../../helpers/DateTime';

const AdminExportsListItem = ({ exportItem }) => (
  <tr>
    <th scope="row">
      {getFormattedDateTime(exportItem.created_at)}
    </th>
    <td className="export-period">
      {exportItem.start_date} - {exportItem.end_date}
    </td>
    <td className="export-results">
      {exportItem.results}
    </td>
    <td className="export-status">
      {exportItem.status}
    </td>
    <td className="action-more">
      {(exportItem.status === 'ready' && exportItem.results > 0 && exportItem.path) && (
        <a
          href={exportItem.path}
          download
        >
          <i className="far fa-download" />
        </a>
      )}
    </td>
  </tr>
);

AdminExportsListItem.propTypes = {
  exportItem: PropTypes.object.isRequired,
};

export default connect()(AdminExportsListItem);
